<div fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError.message}}
  </div>

  <mat-chip-listbox>
    <ng-container *ngFor="let researcher of selectedResearchers">
      <mat-chip-option (click)="removeChip(researcher)">
        {{researcher.firstName}} {{researcher.lastName}} {{researcher.email}}
        <mat-icon class="mat-chip-remove">cancel</mat-icon>
      </mat-chip-option>
    </ng-container>
  </mat-chip-listbox>
  <mat-form-field>
    <mat-label>Researchers</mat-label>
    <input matInput #in [matAutocomplete]="auto" [(ngModel)]="inputString" (ngModelChange)="showFilteredData()"
      cdkFocusInitial autofocus>
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
      (optionSelected)="onOptionClicked($event.option.value)">
      <mat-option *ngFor="let researcher of filteredResearchers" [value]="researcher">
        <div class="researcher-info">
          <div class="name-surname">
            {{researcher?.firstName}} {{researcher?.lastName}}
          </div>
          <div class="email">
            {{researcher?.email}}
          </div>
        </div>
      </mat-option>
    </mat-autocomplete>
    <span *ngIf="loadingResearchers" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-hint *ngIf="!loadingResearchers && filteredResearchers.length === 0" class="color-warn">
      No researchers available.
    </mat-hint>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="box = _box; canceled.emit()" mat-button>Cancel</button>
    <button (click)="addResearchers()" [disabled]="selectedResearchers.length === 0 || saving" color="primary"
      mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>